module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#facebook",
      toString: function () {
        return this.url;
      }
    }